import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1410_103",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1410_103)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.5141 2.70755V3.07643H12.7084C12.8045 3.07643 12.8997 3.09554 12.9885 3.13266C13.0772 3.16978 13.1579 3.22419 13.2259 3.29279C13.2938 3.36138 13.3477 3.44282 13.3845 3.53244C13.4213 3.62206 13.4402 3.71812 13.4402 3.81513C13.4402 3.91213 13.4213 4.00819 13.3845 4.09781C13.3477 4.18743 13.2938 4.26887 13.2259 4.33746C13.1579 4.40606 13.0772 4.46047 12.9885 4.49759C12.8997 4.53471 12.8045 4.55382 12.7084 4.55382H3.93196C3.73788 4.55382 3.55175 4.47599 3.41452 4.33746C3.27729 4.19893 3.2002 4.01104 3.2002 3.81513C3.2002 3.61921 3.27729 3.43132 3.41452 3.29279C3.55175 3.15426 3.73788 3.07643 3.93196 3.07643H6.12538V2.70755C6.12538 2.4138 6.24097 2.13209 6.44673 1.92438C6.65249 1.71667 6.93157 1.59998 7.22255 1.59998H9.41691C9.7079 1.59998 9.98697 1.71667 10.1927 1.92438C10.3985 2.13209 10.5141 2.4138 10.5141 2.70755ZM4.23773 13.4883C4.16756 13.3092 4.13145 13.1171 4.13145 12.9232V5.90739C4.13145 5.80954 4.1682 5.71569 4.23362 5.6465C4.29903 5.57731 4.38776 5.53843 4.48028 5.53843H12.1608C12.2066 5.53843 12.252 5.54798 12.2943 5.56652C12.3366 5.58506 12.3751 5.61224 12.4075 5.6465C12.4398 5.68076 12.4655 5.72143 12.4831 5.7662C12.5006 5.81096 12.5096 5.85894 12.5096 5.90739V12.9232C12.5096 13.1171 12.4735 13.3092 12.4033 13.4883C12.3332 13.6675 12.2303 13.8303 12.1007 13.9674C11.971 14.1046 11.8171 14.2133 11.6477 14.2876C11.4783 14.3618 11.2968 14.4 11.1134 14.4H5.52766C5.34431 14.4 5.16275 14.3618 4.99335 14.2876C4.82396 14.2133 4.67004 14.1046 4.54039 13.9674C4.41074 13.8303 4.30789 13.6675 4.23773 13.4883Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgRemove);
export default ForwardRef;
